{
  "version": 1,
  "asset_id": "26e7d76c-cc08-482c-9fe1-efdc23d8dbe5",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/26e7d76c-cc08-482c-9fe1-efdc23d8dbe5/g25.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/26e7d76c-cc08-482c-9fe1-efdc23d8dbe5/g25.jpg",
  "original_filename": "g25.jpg",
  "size": 78860,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T23:00:11Z"
}
